import React from 'react';
import { Warning, WarningPrimitives } from 'venn-ui-kit';
import type { ValidationError } from './useSubjectGroupErrors';
import { Match } from 'effect';

type BlockSubjectInputWarningProps = {
  error: ValidationError;
};

export const BlockSubjectInputWarning = ({ error }: BlockSubjectInputWarningProps) =>
  Match.value(error).pipe(
    Match.when({ type: 'ERROR', problem: 'CONTAINS_HISTORICAL_PORTFOLIO' }, (error) => (
      <WarningPrimitives.Wrapper key={error.message} className="[&&]:bg-venn-error/15">
        <WarningPrimitives.Icon type="triangle-exclamation" prefix="far" className="[&&]:text-venn-error" />
        {error.message}
      </WarningPrimitives.Wrapper>
    )),
    Match.when({ type: 'ERROR', problem: 'MISSING_SUBJECT' }, (error) => (
      <Warning key={error.message} text={error.message} />
    )),
    Match.when({ type: 'WARNING' }, () => <Warning key={error.message} text={error.message} />),
    Match.exhaustive,
  );
